module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/mineral_water-b145bdd1b7ea4e240e53b9f3417a75b4.svg";